import { stringify, type IStringifyOptions } from 'qs';

export type QueryObject = Record<string, unknown>;

const QS_OPTIONS: IStringifyOptions = { arrayFormat: 'indices', format: 'RFC1738' };

export function serializeQuery(params: QueryObject): string {
  return stringify(params, QS_OPTIONS);
}
